export enum PasswordChangeErrors {
  INCORRECT_EMAIL = 'Введите корректный email.',
  INCORRECT_PASSWORD = 'Пароль должен быть длинной от 8 до 16 символов.',
  PASSWORDS_NOT_MATCH = 'Пароли не совпадают.',
  NO_ERRORS = '',
}
